export default __webpack_public_path__ + "static/media/bg.9edd2941.jpg";